import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Chatroom, leaveRoom } from 'nm-react-chat';

import Aux from './../../hoc/_Aux';

import { hideComment } from './../../components/Article/articleActions';
import { readCGU } from './../../components/user/userActions';

import WavyLayout from './../../hoc/WavyLayout/WavyLayout';

import DoubleHalfCircle from './../UI/Common/Shapes/DoubleHalfCircle';
import Triangle from './../UI/Common/Shapes/Triangle';
import Modal from './../../components/UI/Modal/Modal';


export class Comments extends Component {

    state = {
        showCGU: false
    }

    handleCloseClick = () => {
        const { dispatch } = this.props;
        dispatch(leaveRoom());
        dispatch(hideComment());
    }

    CGUClickHandler = () => {
        this.setState({showCGU:true});
    }

    CGUCloseHandler = () => {
        this.setState({showCGU:false});
    }

    CGUFirstTimeCloseHandler = () => {
        const {dispatch} = this.props;
        this.setState({showCGU:false});
        dispatch(readCGU());
    }

    render(){
        const { chatroomId, showComment, commentReadGCU } = this.props;
        let chatroom = '';
        let comment = null;

        if(chatroomId !== '')
        {
            chatroom = (<Chatroom />);
        }

        if(showComment) {
            comment = (
                <WavyLayout
                    page="comment"
                    title="Laisse ton comm'"
                    color="#241459"
                    translate="40px"
                    handleClick={this.handleCloseClick}>
                    <div className="pink-triangle">
                        <Triangle color="#ff8377" rotateAngle="-4" />
                    </div>
                    <div className="dual-half-circle">
                        <DoubleHalfCircle color1='#fced98' color2='#fd8598' rotateAngle="95"/>
                    </div>
                    <div className="cgu" onClick={this.CGUClickHandler}>?</div>
                    {chatroom}  
                </WavyLayout>
            );
        }

        let CGUModalClass = "cgu";
        if(commentReadGCU)
        {
            CGUModalClass += " short";
        }

        return(
            <Aux>
                <Modal show={this.state.showCGU || (showComment && !commentReadGCU)} modalClosed={this.CGUCloseHandler} class={CGUModalClass} >
                    <div className="modal-container-cgu">
                        {commentReadGCU && <div className="close-modal-cgu" onClick={this.CGUCloseHandler} > </div>}
                        <div className="image"></div>
                        <div className="title">Ne communique jamais<br /> tes coordonnées<br /> ou celle de tes parents</div>
                        <p  className="text">Il est interdit de prononcer des propos injurieux ou violents</p>
                        <p  className="text">Tu peux signaler un <br />commentaire si l'un d'entre<br /> eux est inadapté en cliquant <br />sur le commentaire</p>
                        <p  className="text">Il est très important<br /> que tu limites les interactions<br /> avec les inconnus</p>
                        {!commentReadGCU && <div className="button" onClick={this.CGUFirstTimeCloseHandler}>Ok, j'ai compris</div>}
                    </div>
                </Modal>
                {comment}
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        chatroomId: state.chatroom.chatroomId,
        showComment: state.article.showComment,
        commentReadGCU: state.user.commentCGURead
    }
};

export default connect( mapStateToProps )(Comments);




// WEBPACK FOOTER //
// ./src/containers/Comment/Comment.js